module.exports = __webpack_public_path__ + "img/delay_6.aca80a1d.svg";